import { render, staticRenderFns } from "./Calibration.vue?vue&type=template&id=3947a515&scoped=true&"
import script from "./Calibration.vue?vue&type=script&lang=js&"
export * from "./Calibration.vue?vue&type=script&lang=js&"
import style0 from "./Calibration.vue?vue&type=style&index=0&id=3947a515&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3947a515",
  null
  
)

export default component.exports